import { render, staticRenderFns } from "./CartHeader.vue?vue&type=template&id=59cd7dac&"
import script from "./CartHeader.vue?vue&type=script&lang=ts&"
export * from "./CartHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports